module.exports = __webpack_public_path__ + "static/media/why2.f785d26e.png";